import { Modal } from '@enterprise-ui/canvas-ui-react'

export const CostRangeExplanationModal = (props) => {
  const labelText = props.fieldLabel || 'Current Cost(s)'
  return (
    <Modal headingText={labelText} {...props}>
      <div className="hc-pa-normal">
        <p>
          {`${labelText} represents the range of current cost values across all the
          Target store locations that correspond with the location of the given
          row.`}
        </p>
        <p>
          {`For example, if you were to only see a single cost value, that would
          indicate that all of the store locations corresponding to that row
          have the same cost value. If you see a range, such as $10.00 - $15.00
          in the ${labelText} column, you’ve chosen to view by State, and you see
          “MN” in the state column, that indicates at least one store location
          in Minnesota has a cost value set as low as $10.00, while another has
          a cost value set as high as $15.00.`}
        </p>
      </div>
    </Modal>
  )
}
